export default __webpack_public_path__ + "static/media/about_background3.43739040.png";